module.exports = __webpack_public_path__ + "static/media/prog-cms.59eb60e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/prog-cms.png
// module id = 1531
// module chunks = 1